// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__376dj","modal":"Modal_modal__jWqPC","slide-down":"Modal_slide-down__I7oyo"};